import React from 'react';
import contact from '../../content/contact.json';

const ContactUs = () => {
  return (
    <section name="contact-us" id="contact-us" className="bg-pink-light scroll-to spacer block including-image no-padding p-top-xl">

      <div className="text-wrapper text-center">
        <div className="title">
          <h2>{contact.title}</h2>
        </div>
        <div className="content">
          <p>Tel.:  <a href={`tel:${contact.phoneLink}`}>{contact.phone}</a></p>
          <p>Adresse: <a href={contact.mapsUrl}>{contact.address}</a></p>
        </div>

        <div className="button-wrapper">
          <a href={`mailto:${contact.email}`} className="btn btn-outline-secondary">{contact.buttonLabel}</a>
        </div>
      </div>

      <div className="block img img-gray" style={ { backgroundImage: `url(${contact.image})` } }></div>
    </section>
  );
};

export default ContactUs;
